import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PastMedication from '../past-medication/past-medication';
import CurrentMedication from '../current-medication/current-medication';
import { get } from '../../../utils/fetchAPI';

const TABS = [
    { id: 'current', name: 'Current Medication' },
    { id: 'past', name: 'Past Medication' },
];

// Visit sidebar section 18: Current Medication and Past Medication as two tabs. Staff
// see only Current Medication — Past Medication stays a doctor's list.
//
// Both lists live on the patient, so both need the patient document. The appointment
// page already loads it; the waiting-room page does not, so fall back to fetching it.
const MedicationSection = ({ visitDetails, patientDetails, updateState, patientId }) => {
    const { user } = useSelector((state) => state.auth);
    const isStaff = user?.user?.type === 'staff';
    // Default to Current: it is the only place current medication is recorded, while
    // Past Medication is the longer-lived list a doctor curates less often.
    const [tab, setTab] = useState('current');

    const [ownPatient, setOwnPatient] = useState(null);
    const needsOwnFetch = !patientDetails?._id && Boolean(patientId);

    useEffect(() => {
        if (!needsOwnFetch) return;
        let cancelled = false;
        get(`/patient/${patientId}`)
            .then((res) => { if (!cancelled && res?.status === 200) setOwnPatient(res.data); })
            .catch(() => { });
        return () => { cancelled = true; };
    }, [needsOwnFetch, patientId]);

    const patient = patientDetails?._id ? patientDetails : ownPatient;
    const setPatient = patientDetails?._id ? updateState : setOwnPatient;

    if (isStaff) {
        return (
            <CurrentMedication
                visitDetails={visitDetails}
                patientDetails={patient}
                updateState={setPatient}
                patientId={patientId}
            />
        );
    }

    // Only the active tab is mounted: both panels read the same global
    // state.prescription search results, so two mounted panels would overwrite each
    // other's drug-search list.
    const strip = (
        <div className="pm-tabs">
            {TABS.map((option) => (
                <button
                    key={option.id}
                    type="button"
                    className={`pm-tab${tab === option.id ? ' pm-tab--active' : ''}`}
                    onClick={() => setTab(option.id)}
                >
                    {option.name}
                </button>
            ))}
        </div>
    );

    return tab === 'past' ? (
        <PastMedication
            headerSlot={strip}
            visitDetails={visitDetails}
            patientDetails={patient}
            updateState={setPatient}
            patientId={patientId}
        />
    ) : (
        <CurrentMedication
            headerSlot={strip}
            visitDetails={visitDetails}
            patientDetails={patient}
            updateState={setPatient}
            patientId={patientId}
        />
    );
};

export default MedicationSection;
